import React, { createContext, useState, useContext } from 'react';
import Toast from './Toast';

// Créer le contexte
const ToastContext = createContext();

// Hook personnalisé pour utiliser le contexte
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

// Provider qui va envelopper l'application
export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  // Ajouter un nouveau toast
  const showToast = (message, type = 'info', duration = 5000) => {
    const id = Math.random().toString(36).substring(2, 9);
    setToasts((prevToasts) => [...prevToasts, { id, message, type, duration }]);
    return id;
  };

  // Raccourcis pour les différents types de toasts
  const showError = (message, duration) => showToast(message, 'error', duration);
  const showSuccess = (message, duration) => showToast(message, 'success', duration);
  const showInfo = (message, duration) => showToast(message, 'info', duration);
  const showWarning = (message, duration) => showToast(message, 'warning', duration);

  // Supprimer un toast
  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter(toast => toast.id !== id));
  };

  // Valeur du contexte
  const contextValue = {
    showToast,
    showError,
    showSuccess,
    showInfo,
    showWarning,
    removeToast
  };

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <div className="toast-wrapper">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            onClose={() => removeToast(toast.id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export default ToastContext; 